import React, {useMemo} from 'react';
import PropTypes from 'prop-types';


import Select from '../../../global/Form/Select';
import {CountryFlag, useCountries} from '../index';

import styles from './CountrySelect.scss';


function CountrySelect(props) {

    const countries = useCountries();

    const filteredCountries = useMemo(() => {

        const {filterCountriesAlpha2} = props;
        if (filterCountriesAlpha2.length === 0) {

            return countries;
        }

        return countries.filter(({alpha2}) => filterCountriesAlpha2.includes(alpha2));
    }, [countries, props.filterCountriesAlpha2]);

    if (countries.length === 0) {

        return null;
    }

    const defaultRenderContent = ({name, nativeName}) => (
        <>
            {name} <span>({nativeName})</span>
        </>
    );
    const defaultRenderSelectedContent = ({alpha2, name}) => (
        <>
            <CountryFlag countryAlpha2={alpha2}/> {name}
        </>
    );

    const renderContent = props.renderContent || defaultRenderContent;
    const renderSelectedContent = props.renderSelectedContent || defaultRenderSelectedContent;

    return (
        <Select
            {...props}
            className={styles.countrySelect}
            searchPredicate={({term}, {alpha2, name, nativeName}) => {

                const fields = [
                    alpha2,
                    name,
                    nativeName
                ];

                return !!fields.find(fieldValue => fieldValue.toLowerCase().indexOf(term) !== -1);
            }}
            onChange={countryAlpha2 => props.onChange(countryAlpha2)}
            options={filteredCountries.map(country => {

                return {
                    content: renderContent(country),
                    data: country,
                    label: country.name,
                    selectedContent: renderSelectedContent(country),
                    value: country.alpha2
                };
            })}
            value={props.value}
        />
    );
}


CountrySelect.propTypes = {
    ...Select.propTypes,
    filterCountriesAlpha2: PropTypes.arrayOf(PropTypes.string),
    renderContent: PropTypes.func,
    renderSelectedContent: PropTypes.func
};

CountrySelect.defaultProps = {
    ...Select.defaultProps,
    filterCountriesAlpha2: []
};


export default CountrySelect;
